import request from '@/utils/request'

export function addService(data) {
	return request({
		method: 'post',
		url: '/WebApi/addServiceRegistry',
		data: data
	})
}

export function addSupport(data) {
	return request({
		method: 'post',
		url: '/WebApi/addServiceSupport',
		data: data
	})
}

export function addCooperation(data) {
	return request({
		method: 'post',
		url: '/WebApi/addCooperation',
		data: data
	})
}
